<script>
	import { page } from '$app/state';
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import CommercialInsulation from '$lib/PageSections/CommercialInsulation/CommercialInsulation.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import HomepageBanner from '$lib/PageSections/HomepageBanner/HomepageBanner.svelte';
	import IndowPerformance from '$lib/PageSections/IndowPerformance/IndowPerformance.svelte';
	import IndowVsReplacements from '$lib/PageSections/IndowVsReplacements/IndowVsReplacements.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';
	import TrustedChoice from '$lib/PageSections/TrustedChoice/TrustedChoice.svelte';
	import WindowWorries from '$lib/PageSections/WindowWorries/WindowWorries.svelte';
</script>

<svelte:head>
	<meta
		property="og:image"
		content={`${page?.url?.origin}/static/images/image_for_social_open_graph-1200x630.jpg`}
	/>
	<meta property="og:image:alt" content="woman holding Indow insert" />
	<meta property="og:image:width" content="1200" />
	<meta property="og:image:height" content="630" />
	<meta
		property="twitter:image"
		content={`${page?.url?.origin}/static/images/image_for_social_open_graph-1200x630.jpg`}
	/>
	<meta property="twitter:image:alt" content="woman holding Indow insert" />
</svelte:head>
<HomepageBanner />

<Section backgroundColor="white">
	<h1
		class="
    text-left
    md:text-center
  "
	>
		Eliminate Your Window Worries With Indow Window Inserts
	</h1>
	<p
		class="
    text-left
    md:text-center
  "
	>
		Indow inserts are like building an invisible wall in your windows - blocking
		out unwelcome intrusions - like cold drafts & noisy neighbors - without
		blocking the light.
	</p>

	<WindowWorries />

	<p class="text-left">
		Indow inserts provide excellent climate control while blocking condensation,
		traffic noise, seasonal pollen, and so much more. No matter what issues
		plague your leaky windows, Indow inserts are the clear choice for superior
		insulation - without the hassle and high cost of window replacements.
	</p>

	<Button class="mb-8" href="/solutions/window-insulation">
		See All Solutions
	</Button>

	<CommercialInsulation />
</Section>

<IndowPerformance />
<TrustedChoice />

<Section>
	<IndowVsReplacements />
</Section>

<GetAFreeEstimate />
<Reviews />
<FeaturedArticles />
